module.exports = __webpack_public_path__ + "static/media/5.d027e77f.jpg";